import { lazy } from "react"

export const FinanceDataByIdPage = lazy(() => import("./FinanceDataByIdPage"))